import { reducer, initialStateBase } from './newCollection';

export const CHECKOUT_PAGE = 'CHECKOUT_PAGE';
export const LIST_BANK = 'LIST_BANK';
export const VERIFY_BANK = 'VERIFY_BANK';
export const PAYMENT_METHODS = 'PAYMENT_METHODS';
export const CREATE_RESERVATION = 'CREATE_RESERVATION';
export const RESERVATION_DETAIL = 'RESERVATION_DETAIL';
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION';
export const CANCEL_RESERVATION = 'CANCEL_RESERVATION';
export const RECEIVE_DOWNLOAD_RECEIPT = 'RECEIVE_DOWNLOAD_RECEIPT';
export const ERROR_DOWNLOAD_RECEIPT = 'ERROR_DOWNLOAD_RECEIPT';
export const REQUEST_DOWNLOAD_RECEIPT = 'REQUEST_DOWNLOAD_RECEIPT';

export const urls = {
    getCheckoutPageData: id => `/api/reservations/checkout/${id}`,
    getListBank: '/s3config/external/base/plutus/banks.json',
    verifyBankAccount: '/api/payment/bank/verify',
    getListBankPaymentMethods: '/api/payment/methods',
    createReservation: '/api/reservations/buyer/reserve',
    getReservationDetailPageData: id => `/api/reservations/buyer/${id}`,
    getReceipt: id => `/api/reservations/receipt/${id}`
};

// "https://api.olx.co.id/api/v1/reservations/receipt/27371"

export const initialState = {
    ...initialStateBase,
    isSuccessVerify: false,
    isLoadingCreateReservation: false,
    isErrorCreateReservation: false,
    errorReservationData: {
        errorCode: '',
        message: '',
        field: []
    },
    isSuccessCreateReservation: false,
    isSuccessUpdateReservation: false,
    isSuccessCancelReservation: false,
    isSuccessDownloadPaymentReceipt: false,
    isFetchingDownloadPaymentReceipt: false,
    isFetchingPaymentMethod: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_${LIST_BANK}`: {
            const newState = reducer(state, action, LIST_BANK);

            return {
                ...newState,
                listBank: action.data.data
            };
        }
        case `REQUEST_${VERIFY_BANK}`: {
            const newState = reducer(state, action, VERIFY_BANK);

            return {
                ...newState,
                isSuccessVerify: false
            };
        }
        case `RESPONSE_POST_${VERIFY_BANK}`: {
            const newState = reducer(state, action, VERIFY_BANK);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    verifyBankAccountData: action.data
                },
                isSuccessVerify: true
            };
        }
        case `ERROR_POST_${VERIFY_BANK}`: {
            const newState = reducer(state, action, VERIFY_BANK);

            return {
                ...newState,
                isSuccessVerify: false
            };
        }
        case `REQUEST_${CHECKOUT_PAGE}`: {
            const newState = reducer(state, action, CHECKOUT_PAGE);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    verifyBankAccountData: null
                },
                isSuccessVerify: false,
                isSuccessCreateReservation: false,
                isLoadingCreateReservation: false,
                isErrorCreateReservation: false,
                isSuccessUpdateReservation: false,
                isSuccessCancelReservation: false,
                isSuccessDownloadPaymentReceipt: false,
                isErrorDownloadPaymentReceipt: false,
                errorReservationData: {
                    errorCode: '',
                    message: '',
                    field: []
                }
            };
        }
        case `RECEIVE_${CHECKOUT_PAGE}`: {
            const newState = reducer(state, action, CHECKOUT_PAGE);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    pageData: action.data.data
                }
            };
        }
        case `ERROR_${CHECKOUT_PAGE}`: {
            const newState = reducer(state, action, CHECKOUT_PAGE);

            return {
                ...newState,
                errorReservationData: {
                    error: action.data.error,
                    message: action.data.message,
                    field: []
                }
            };
        }
        case `REQUEST_${PAYMENT_METHODS}`: {
            const newState = reducer(state, action, PAYMENT_METHODS);

            return {
                ...newState,
                isFetchingPaymentMethod: true
            };
        }
        case `RECEIVE_${PAYMENT_METHODS}`: {
            const newState = reducer(state, action, PAYMENT_METHODS);

            return {
                ...newState,
                listPaymentMethods: action.data,
                isFetchingPaymentMethod: false

            };
        }
        case `ERROR_${PAYMENT_METHODS}`: {
            const newState = reducer(state, action, PAYMENT_METHODS);

            return {
                ...newState,
                isFetchingPaymentMethod: false
            };
        }
        case `REQUEST_${CREATE_RESERVATION}`: {
            return {
                ...state,
                isLoadingCreateReservation: true,
                isErrorCreateReservation: false,
                isSuccessCreateReservation: false
            };
        }
        case `ERROR_POST_${CREATE_RESERVATION}`: {
            return {
                ...state,
                errorReservationData: {
                    error: action.data.error,
                    message: action.data.message
                },
                isLoadingCreateReservation: false,
                isErrorCreateReservation: true,
                isSuccessCreateReservation: false
            };
        }
        case `RESET_${CREATE_RESERVATION}`: {
            return {
                ...state,
                isSuccessVerify: false,
                isLoadingCreateReservation: false,
                isErrorCreateReservation: false,
                errorReservationData: {
                    errorCode: '',
                    message: '',
                    field: []
                },
                isSuccessCreateReservation: false,
                isSuccessUpdateReservation: false,
                isSuccessCancelReservation: false,
                isSuccessDownloadPaymentReceipt: false,
                isErrorDownloadPaymentReceipt: false,
                elements: {
                    ...state.elements,
                    verifyBankAccountData: null
                }
            };
        }
        case `RESPONSE_POST_${CREATE_RESERVATION}`: {
            const newState = reducer(state, action, CREATE_RESERVATION);

            return {
                ...newState,
                errorReservationData: {
                    message: null,
                    field: []
                },
                elements: {
                    ...newState.elements,
                    dataReservation: action.data.data
                },
                isLoadingCreateReservation: false,
                isErrorCreateReservation: false,
                isSuccessCreateReservation: true
            };
        }
        case `REQUEST_${RESERVATION_DETAIL}`: {
            const newState = reducer(state, action, RESERVATION_DETAIL);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    verifyBankAccountData: null
                },
                isSuccessVerify: false,
                isSuccessCreateReservation: false,
                isLoadingCreateReservation: false,
                isErrorCreateReservation: false,
                isSuccessUpdateReservation: false,
                isSuccessCancelReservation: false,
                isSuccessDownloadPaymentReceipt: false,
                isErrorDownloadPaymentReceipt: false,
                errorReservationData: {
                    error: '',
                    message: '',
                    field: []
                }
            };
        }
        case `RECEIVE_${RESERVATION_DETAIL}`: {
            const newState = reducer(state, action, RESERVATION_DETAIL);

            return {
                ...newState,
                elements: {
                    ...newState.elements,
                    pageData: action.data.data
                }
            };
        }
        case `ERROR_${RESERVATION_DETAIL}`: {
            const newState = reducer(state, action, RESERVATION_DETAIL);

            return {
                ...newState,
                isSuccessUpdateReservation: false,
                errorReservationData: {
                    error: action.data.error,
                    message: action.data.message,
                    field: []
                }
            };
        }
        case `REQUEST_${UPDATE_RESERVATION}`: {
            const newState = reducer(state, action, UPDATE_RESERVATION);

            return {
                ...newState,
                isSuccessUpdateReservation: false,
                errorReservationData: {
                    error: '',
                    message: '',
                    field: []
                }
            };
        }
        case `RESPONSE_PATCH_${UPDATE_RESERVATION}`: {
            const newState = reducer(state, action, UPDATE_RESERVATION);

            return {
                ...newState,
                isSuccessUpdateReservation: true,
                errorReservationData: {
                    message: null,
                    field: []
                }
            };
        }
        case `ERROR_PATCH_${UPDATE_RESERVATION}`: {
            const newState = reducer(state, action, UPDATE_RESERVATION);

            return {
                ...newState,
                isSuccessUpdateReservation: false,
                errorReservationData: {
                    error: action.data.error,
                    message: action.data.message,
                    field: []
                }
            };
        }
        case `REQUEST_${CANCEL_RESERVATION}`: {
            const newState = reducer(state, action, CANCEL_RESERVATION);

            return {
                ...newState,
                isSuccessCancelReservation: false,
                errorReservationData: {
                    error: '',
                    message: '',
                    field: []
                }
            };
        }
        case `RESPONSE_PATCH_${CANCEL_RESERVATION}`: {
            const newState = reducer(state, action, CANCEL_RESERVATION);

            return {
                ...newState,
                isSuccessCancelReservation: true,
                errorReservationData: {
                    message: null,
                    field: []
                }
            };
        }
        case `ERROR_PATCH_${CANCEL_RESERVATION}`: {
            const newState = reducer(state, action, CANCEL_RESERVATION);

            return {
                ...newState,
                isSuccessCancelReservation: false,
                errorReservationData: {
                    error: action.data.error,
                    message: action.data.message,
                    field: []
                }
            };
        }
        case REQUEST_DOWNLOAD_RECEIPT : {
            return {
                ...state,
                isFetchingDownloadPaymentReceipt: true,
                isSuccessDownloadPaymentReceipt: false,
                isErrorDownloadPaymentReceipt: false
            };
        }
        case RECEIVE_DOWNLOAD_RECEIPT : {
            return {
                ...state,
                isFetchingDownloadPaymentReceipt: false,
                isSuccessDownloadPaymentReceipt: true,
                isErrorDownloadPaymentReceipt: false
            };
        }
        case ERROR_DOWNLOAD_RECEIPT : {
            return {
                ...state,
                isFetchingDownloadPaymentReceipt: false,
                isSuccessDownloadPaymentReceipt: false,
                isErrorDownloadPaymentReceipt: true
            };
        }
        default:
            return reducer(state, action, CHECKOUT_PAGE);
    }
};

